export default "__VITE_ASSET__CgXMQwFz__"